import Localbase from 'localbase';
import * as moment from 'moment';
import { StorageGroup, StorageTable } from 'src/app/features/cache/cache-table';
import { environment } from 'src/environments/environment';

export type GioStorageType = 'INDEXEDDB' | 'WEBSQL' | 'LOCALSTORAGE';

export interface GioStorageDocument<T = any> {
  update: (value: Partial<T>) => Promise<T>;
  set: (value: Partial<T>) => Promise<T>;
  get: () => Promise<T>;
  add: (value: Partial<T>, key?: string) => Promise<T>;
  delete: () => Promise<any>;

}
export interface GioStorageCollection<T = any> {
  add: (value: T) => Promise<T>;
  get: () => Promise<T[]>;
  doc: (key: string) => GioStorageDocument<T>;
  set: (values: Partial<T>[]) => Promise<T[]>;
  delete: () => Promise<void>;
  orderBy: (key: string, order?: 'desc') => GioStorageCollection;
  limit: (items: number) => GioStorageCollection;
}

export class GioStorage<T = any> {
  private static _instance: GioStorage;
  private db: any;
  private _dbName = 'gioco-cache';

  private constructor() {
    this.db = new Localbase(this._dbName);
    this.registerDB();
    if (environment.environment == 'production') {
      this.db.config.debug = false;
    }
    this.db.config.debug = false;
  }

  public static getInstance(): GioStorage {
    if (!this._instance) {
      this._instance = new GioStorage();
    }

    return this._instance;
  }

  collection<Y = T>(collectionName: string) {
    this.db.docSelectionCriteria = null;
    return this.db.collection(collectionName) as GioStorageCollection<Y>;
  }

  delete(): Promise<void> {
    return this.db.delete();
  }

  private async registerDB() {
    const collection = this.collection('databases');
    const doc = collection.doc(this._dbName);
    const inDb = await doc.get();

    if (!inDb) {
      try {
        await this.collection<any>('databases').doc(this._dbName).set({ id: this._dbName, createdAt: moment().toISOString() });
      } catch (error) {
        console.error('Erro criando o cache');
      }

    }
  }

  async listStorages() {
    const databases = await this.collection<{ id: string, createdAt: string }>('databases').get();
    return databases;
  }

  async listTables() {
    const databases = await this.collection<StorageTable>('tables').get();
    return databases;
  }

  async records<Y = T>(tableName: string): Promise<Y[]> {
    const databases = await this.collection<Y>(tableName).get();
    return databases;
  }



  getStorageType(): GioStorageType {
    if (!this.db.lf) {
      return null;
    }
    const api = this.db.lf?.api?._driver;

    switch (api) {
      case 'asyncStorage': return 'INDEXEDDB';
      case 'webSQLStorage': return 'WEBSQL';
      case 'localStorageWrapper': return 'LOCALSTORAGE';
      default: return null;
    }
  }


}
